var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMastercard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 780,
    height: "23px",
    viewBox: "0 0 780 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,61.513C14,40.881,30.453,24,50.563,24H757.438C777.547,24,794,40.881,794,61.513V486.659c0,20.632-16.453,37.513-36.562,37.513H50.563C30.453,524.172,14,507.292,14,486.659Z",
    transform: "translate(-14 -24)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 131.625,
    height: 215.109
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M103.181,134.587V111.431c0-8.531-4.875-14.016-14.016-14.625-4.875,0-9.141,1.219-12.8,6.7-2.437-4.266-6.7-6.7-12.187-6.7a12.955,12.955,0,0,0-10.969,5.484V98.025H45.9v36.563h7.313V113.869c0-6.094,3.656-9.75,9.141-9.75s7.922,3.656,7.922,9.75v20.719h7.313V113.869c0-6.094,3.656-9.75,9.141-9.75s8.531,3.656,8.531,9.75v20.719ZM221.4,98.025H207.994V87.056h-7.312V98.025h-7.922v6.7h7.922v17.063c0,8.531,3.047,13.406,12.188,13.406a16.86,16.86,0,0,0,9.75-3.047l-2.437-6.7a15.888,15.888,0,0,1-6.7,1.828c-3.656,0-5.484-2.438-5.484-6.094V104.119H221.4Zm67.641-.609c-4.266,0-7.922,1.828-9.75,5.484V98.634h-7.312V135.2h7.313V114.478c0-6.094,3.047-9.75,7.922-9.75a7.327,7.327,0,0,1,4.875,1.219l2.438-6.7A7.366,7.366,0,0,0,289.041,97.416Zm-102.375,3.656c-3.656-2.438-9.141-3.656-14.625-3.656-9.141,0-14.625,4.266-14.625,11.578,0,6.094,4.266,9.75,12.188,10.359l3.656.609c4.266.609,6.7,1.828,6.7,4.266,0,3.047-3.047,4.875-8.531,4.875a22.234,22.234,0,0,1-12.187-3.656l-3.656,5.484a29.507,29.507,0,0,0,15.844,4.875c10.359,0,16.453-4.875,16.453-11.578,0-6.094-4.266-9.75-12.187-10.969l-3.656-.609c-3.656-.609-6.7-1.219-6.7-3.656s3.047-4.266,7.313-4.266a26.471,26.471,0,0,1,11.578,3.047Zm110.3,15.234c0,10.969,7.313,18.891,18.891,18.891,5.484,0,9.141-1.219,12.8-4.266l-3.656-5.484a18.413,18.413,0,0,1-9.75,3.047c-6.094,0-10.969-4.875-10.969-12.187s4.875-12.187,10.969-12.187a18.414,18.414,0,0,1,9.75,3.047l3.656-5.484c-3.656-3.047-7.312-4.266-12.8-4.266C304.275,97.416,296.962,105.337,296.962,116.306ZM245.775,97.416c-10.359,0-17.672,7.922-17.672,18.891,0,11.578,7.312,18.891,18.281,18.891,5.484,0,10.359-1.219,14.625-4.875l-3.656-5.484a16.548,16.548,0,0,1-10.359,3.656c-4.875,0-10.359-3.047-10.969-9.141h27.422v-3.047C262.837,104.728,256.134,97.416,245.775,97.416Zm0,6.7c5.484,0,9.141,3.656,9.75,9.141h-19.5C236.634,107.775,240.291,104.119,245.775,104.119Zm-98.109,12.188V98.025h-7.312v4.266a15.085,15.085,0,0,0-11.578-5.484c-10.359,0-17.672,7.922-17.672,18.891s7.922,18.891,17.672,18.891c4.875,0,9.141-1.828,11.578-5.484v4.266h7.313Zm-29.859,0c0-6.7,4.266-12.187,11.578-12.187,6.7,0,10.969,5.484,10.969,12.188,0,7.313-4.266,12.188-10.969,12.188S117.806,123.009,117.806,116.306ZM398.728,97.416c-4.266,0-7.922,1.828-9.75,5.484V98.634h-7.312V135.2h7.313V114.478c0-6.094,3.047-9.75,7.922-9.75a7.327,7.327,0,0,1,4.875,1.219l2.438-6.7A7.366,7.366,0,0,0,398.728,97.416Zm58.5,31.688h1.219c.609,0,.609.609,1.219.609.609.609.609.609.609,1.219v2.437c0,.609-.609.609-.609,1.219-.609.609-.609.609-1.219.609h-2.437c-.609,0-.609-.609-1.219-.609-.609-.609-.609-.609-.609-1.219v-2.437c0-.609.609-.609.609-1.219.609-.609.609-.609,1.219-.609Zm0,6.7h1.219a.6.6,0,0,0,.609-.609l.609-.609V132.15a.6.6,0,0,0-.609-.609l-.609-.609h-2.437a.6.6,0,0,0-.609.609l-.609.609v2.437a.6.6,0,0,0,.609.609l.609.609Zm0-4.875h1.219l.609.609v.609a.6.6,0,0,0-.609.609l1.219,1.219h-.609l-1.219-1.219h-.609v1.219h-.609v-3.656h.609Zm-.609.609h0l1.219.609v-1.219l-1.219.609ZM370.7,116.306V98.025h-7.312v4.266a15.085,15.085,0,0,0-11.578-5.484c-10.359,0-17.672,7.922-17.672,18.891s7.922,18.891,17.672,18.891c4.875,0,9.141-1.828,11.578-5.484v4.266H370.7Zm-29.25,0c0-6.7,4.266-12.187,11.578-12.187,6.7,0,10.969,5.484,10.969,12.188,0,7.313-4.266,12.188-10.969,12.188C345.712,128.494,341.447,123.009,341.447,116.306Zm102.375,0V83.4h-7.312v18.891a15.085,15.085,0,0,0-11.578-5.484c-10.359,0-17.672,7.922-17.672,18.891s7.922,18.891,17.672,18.891c4.875,0,9.141-1.828,11.578-5.484v4.266h7.313Zm-29.25,0c0-6.7,4.266-12.187,11.578-12.187,6.7,0,10.969,5.484,10.969,12.188,0,7.313-4.266,12.188-10.969,12.188C418.837,128.494,414.572,123.009,414.572,116.306Z",
    transform: "translate(-45.9 -83.4)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M211,172.2c0-43.875,20.719-82.266,52.406-107.25A136.568,136.568,0,1,0,178.7,308.7c31.687,0,60.938-10.969,84.7-29.25A135.14,135.14,0,0,1,211,172.2",
    transform: "translate(-42.2 -35.7)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M114.637,76.584V72.319h1.828v-.609H112.2v.609h1.828l.609,4.266Zm8.531,0V71.1H121.95l-1.828,3.656L118.294,71.1h-1.219v5.484h1.219V72.319l1.219,3.656h1.219l1.219-3.656v4.266Z",
    transform: "translate(-112.2 -71.1)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M299.6,172.2A136.276,136.276,0,0,1,163.1,308.7c-31.687,0-60.938-10.969-84.7-29.25,31.687-24.984,52.406-63.984,52.406-107.25,0-43.875-20.719-82.266-52.406-107.25A136.7,136.7,0,0,1,299.6,172.2",
    transform: "translate(-78.4 -35.7)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14 -24)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(14 24)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,61.513C14,40.881,30.453,24,50.563,24H757.438C777.547,24,794,40.881,794,61.513V486.659c0,20.632-16.453,37.513-36.562,37.513H50.563C30.453,524.172,14,507.292,14,486.659Z",
    transform: "translate(-14 -24)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14,61.513C14,40.881,30.453,24,50.563,24H757.438C777.547,24,794,40.881,794,61.513V486.659c0,20.632-16.453,37.513-36.562,37.513H50.563C30.453,524.172,14,507.292,14,486.659Z",
    transform: "translate(-14 -24)",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(340.625 124.547)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 192.563,
    height: 276.047,
    transform: "translate(-30.469 -30.469)",
    fill: "#ff5f00"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-2.844 7.703)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(208.391 385.969)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 475.922,
    height: 113.953,
    transform: "translate(-30.469 -30.469)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(185.844 95.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282.141,
    height: 334.547,
    transform: "translate(-31.078 -30.469)",
    fill: "#eb001b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(612.406 311.016)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 72.516,
    height: 66.422,
    transform: "translate(-31.078 -30.469)",
    fill: "#f79e1b"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(406.438 95.297)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 282.141,
    height: 334.547,
    transform: "translate(-30.469 -30.469)",
    fill: "#f79e1b"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.a7a38c62.svg";
export { ForwardRef as ReactComponent };